module.exports = __webpack_public_path__ + "assets/img/ds5.73f02203.jpg";